import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/axiosConfig';
import Swal from 'sweetalert2';

// Thunk para obtener las estadísticas del dashboard
export const fetchDashboardStats = createAsyncThunk(
  'dashboard/fetchDashboardStats',
  async (_, { rejectWithValue }) => {
    try {
     
      const response = await api.get('/api/dashboard');
      
      return response.data;
    } catch (error) {
      console.error('[Dashboard] Error al cargar datos:', error);
      console.error('[Dashboard] Respuesta de error:', error.response);
      return rejectWithValue(error.response?.data?.error || 'Error al cargar el dashboard');
    }
  }
);

// Thunk para limpiar sesiones caducadas
export const limpiarSesionesCaducadas = createAsyncThunk(
  'dashboard/limpiarSesionesCaducadas',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: "Esta acción limpiará todas las sesiones caducadas del sistema.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, limpiar sesiones',
        cancelButtonText: 'Cancelar'
      });

      if (!result.isConfirmed) {
        
        return rejectWithValue('Operación cancelada por el usuario');
      }

      
      const response = await api.delete('/api/sesiones/limpiar');
      

      // Mensaje condicional basado en la respuesta
      const successMessage = response.data.estado === 'no_action_required'
        ? response.data.mensaje
        : '¡Sesiones limpiadas!';

      Swal.fire({
        title: successMessage,
        text: response.data.mensaje,
        icon: response.data.estado === 'no_action_required' ? 'info' : 'success'
      });

      
      await dispatch(fetchDashboardStats());

      return response.data;
    } catch (error) {
      console.error('[Sesiones] Error al limpiar sesiones:', error);

      const errorMessage = error.response?.data?.mensaje ||
        error.response?.data?.message ||
        'Error al limpiar sesiones';

      Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error'
      });

      return rejectWithValue(errorMessage);
    }
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    stats: null,
    loading: false,
    error: null,
    cleaningSessions: false,
    lastAction: null
  },
  reducers: {
    clearDashboardError: (state) => {
      
      state.error = null;
    },
    setLastAction: (state, action) => {
      state.lastAction = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        
        state.loading = false;
        state.stats = action.payload;
        state.lastAction = 'fetch_success';
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.payload;
        state.lastAction = 'fetch_error';
      })
      .addCase(limpiarSesionesCaducadas.pending, (state) => {
        
        state.cleaningSessions = true;
        state.lastAction = 'clean_start';
      })
      .addCase(limpiarSesionesCaducadas.fulfilled, (state, action) => {
        
        state.cleaningSessions = false;
        state.lastAction = 'clean_success';

      })
      .addCase(limpiarSesionesCaducadas.rejected, (state, action) => {
        
        state.cleaningSessions = false;
        state.error = action.payload;
        state.lastAction = 'clean_error';
      });
  },
});

export const { clearDashboardError, setLastAction } = dashboardSlice.actions;
export default dashboardSlice.reducer;